import React, { useEffect } from "react";
import cl from "./Policy.module.css";
import { animateScroll as scroll } from "react-scroll";

const Policy = (props) => {
  useEffect(() => {
    scroll.scrollToTop();
  }, []);

  return (
    <section className={cl.app_policy}>
      <h1>Informativa sulla privacy</h1>
      <p>Ultimo aggiornamento: 07 febbraio 2024 </p>
      <p>
        Questa Informativa sulla privacy descrive le nostre politiche e
        procedure in merito alla raccolta, all'uso e alla divulgazione delle tue
        informazioni quando utilizzi il Servizio e ti informa sui tuoi diritti
        alla privacy e su come la legge ti protegge.{" "}
      </p>
      <p>
        Utilizziamo i tuoi dati personali per fornire e migliorare il Servizio.
        Utilizzando il Servizio, accetti la raccolta e l'uso delle informazioni
        in conformità con questa Informativa sulla privacy. Questa Informativa
        sulla privacy è stata creata con l'aiuto del Generatore di Informativa
        sulla privacy.{" "}
      </p>
      <h2>Interpretazione e definizioni </h2>
      <b>Interpretazione </b>
      <p>
        Le parole iniziali in maiuscolo hanno significati definiti nelle
        seguenti condizioni. Le seguenti definizioni avranno lo stesso
        significato indipendentemente dal fatto che appaiano al singolare o al
        plurale.{" "}
      </p>
      <b>Definizioni </b>
      <p>Per i fini di questa Informativa sulla privacy: </p>
      <ul style={{ marginLeft: "30px" }}>
        <li>
          <p>
            <strong>Account</strong> significa un account unico creato per te
            per accedere al nostro Servizio o a parti del nostro Servizio.
          </p>
        </li>
        <li>
          <p>
            <strong>Affiliato</strong> significa un'entità che controlla, è
            controllata o è sotto il controllo comune con una parte, dove
            "controllo" significa proprietà del 50% o più delle azioni,
            interessi patrimoniali o altri titoli aventi diritto di voto per
            l'elezione di direttori o altra autorità gestionale.
          </p>
        </li>
        <li>
          <p>
            <strong>Azienda</strong> (indicata anche come "la Società", "Noi",
            "Il Nostro" o "Il Nostro" in questo Accordo) si riferisce a{" "}
            {props.shopName}.
          </p>
        </li>
        <li>
          <p>
            <strong>Cookies</strong> sono piccoli file che vengono posizionati
            sul tuo computer, dispositivo mobile o qualsiasi altro dispositivo
            da un sito web, contenenti i dettagli della tua cronologia di
            navigazione su quel sito web tra i suoi molteplici utilizzi.
          </p>
        </li>
        <li>
          <p>
            <strong>Paese</strong> si riferisce a: Arkansas, Stati Uniti
          </p>
        </li>
        <li>
          <p>
            <strong>Dispositivo</strong> significa qualsiasi dispositivo che può
            accedere al Servizio come un computer, un cellulare o un tablet
            digitale.
          </p>
        </li>
        <li>
          <p>
            <strong>Dati personali</strong> si riferisce a qualsiasi
            informazione che riguarda un individuo identificato o
            identificabile.
          </p>
        </li>
        <li>
          <p>
            <strong>Servizio</strong> si riferisce al Sito Web.
          </p>
        </li>
        <li>
          <p>
            <strong>Fornitore di servizi</strong> significa qualsiasi persona
            fisica o giuridica che elabora i dati per conto della Società. Si
            riferisce a società o persone terze impiegate dalla Società per
            facilitare il Servizio, per fornire il Servizio per conto della
            Società, per eseguire servizi correlati al Servizio o per assistere
            la Società nell'analisi di come viene utilizzato il Servizio.
          </p>
        </li>
        <li>
          <p>
            <strong>Dati di utilizzo</strong> si riferisce ai dati raccolti
            automaticamente, generati dall'uso del Servizio o
            dall'infrastruttura del Servizio stesso (ad esempio, la durata di
            una visita alla pagina).
          </p>
        </li>
        <li>
          <p>
            <strong>Sito Web</strong> si riferisce a {props.shopName},
            accessibile da {props.domain}
          </p>
        </li>
        <li>
          <p>
            <strong>Tu</strong> significa l'individuo che accede o utilizza il
            Servizio, o l'azienda o altra entità giuridica per conto della quale
            tale individuo accede o utilizza il Servizio, secondo il caso.
          </p>
        </li>
      </ul>
      <h2>Raccolta e Utilizzo dei Tuoi Dati Personali</h2>
      <h3 style={{ marginBottom: "20px" }}>Tipi di Dati Raccolti</h3>
      <h4>Dati Personali</h4>
      <p>
        Mentre utilizzi il Nostro Servizio, potremmo chiederti di fornirci
        determinate informazioni personali identificabili che possono essere
        utilizzate per contattarti o identificarti. Le informazioni personali
        identificabili possono includere, ma non sono limitate a:
      </p>
      <ul style={{ marginBottom: "30px", marginLeft: "30px" }}>
        <li>Dati di Utilizzo</li>
      </ul>
      <h4>Dati di Utilizzo</h4>
      <p>
        I Dati di Utilizzo vengono raccolti automaticamente durante l'utilizzo
        del Servizio.
      </p>
      <p>
        I Dati di Utilizzo possono includere informazioni come l'indirizzo IP
        del tuo dispositivo (ad esempio, indirizzo IP), tipo di browser,
        versione del browser, le pagine del nostro Servizio che visiti, l'ora e
        la data della tua visita, il tempo trascorso su quelle pagine,
        identificatori univoci del dispositivo e altri dati diagnostici.
      </p>
      <p>
        Quando accedi al Servizio tramite un dispositivo mobile, potremmo
        raccogliere automaticamente determinate informazioni, incluso, ma non
        solo, il tipo di dispositivo mobile che utilizzi, il tuo ID univoco del
        dispositivo mobile, l'indirizzo IP del tuo dispositivo mobile, il tuo
        sistema operativo mobile, il tipo di browser Internet mobile che
        utilizzi, identificatori univoci del dispositivo e altri dati
        diagnostici.
      </p>
      <h3>Utilizzo dei tuoi dati personali</h3>
      <p>La Società può utilizzare i Dati Personali per i seguenti scopi:</p>
      <ul style={{ marginLeft: "30px" }}>
        <li>
          <p>
            <strong>Per fornire e mantenere il nostro Servizio</strong>, incluso
            il monitoraggio dell'uso del nostro Servizio.
          </p>
        </li>
        <li>
          <p>
            <strong>Per gestire il tuo Account:</strong> per gestire la tua
            registrazione come utente del Servizio. I Dati Personali che
            fornisci possono darti accesso a diverse funzionalità del Servizio
            disponibili per te come utente registrato.
          </p>
        </li>
        <li>
          <p>
            <strong>Per l'esecuzione di un contratto:</strong> lo sviluppo, il
            rispetto e l'assunzione del contratto di acquisto dei prodotti,
            articoli o servizi che hai acquistato o di qualsiasi altro contratto
            con noi attraverso il Servizio.
          </p>
        </li>
        <li>
          <p>
            <strong>Per contattarti:</strong> Per contattarti via email,
            telefonate, SMS o altre forme equivalenti di comunicazione
            elettronica, come le notifiche push di un'applicazione mobile
            riguardanti gli aggiornamenti o le comunicazioni informative
            relative alle funzionalità, ai prodotti o ai servizi contrattati,
            inclusi gli aggiornamenti sulla sicurezza, quando necessario o
            ragionevole per la loro implementazione.
          </p>
        </li>
        <li>
          <p>
            <strong>Per fornirti</strong> notizie, offerte speciali e
            informazioni generali su altri beni, servizi ed eventi che offriamo
            e che sono simili a quelli che hai già acquistato o di cui hai
            richiesto informazioni, a meno che tu non abbia scelto di non
            ricevere tali informazioni.
          </p>
        </li>
        <li>
          <p>
            <strong>Per gestire le tue richieste:</strong> Per gestire le tue
            richieste nei nostri confronti.
          </p>
        </li>
        <li>
          <p>
            <strong>Per trasferimenti aziendali:</strong> Possiamo utilizzare le
            tue informazioni per valutare o effettuare una fusione, cessione,
            ristrutturazione, riorganizzazione, liquidazione o altra vendita o
            trasferimento di parte o di tutti i nostri beni, sia come azienda in
            attività che come parte di fallimento, liquidazione o procedura
            simile, in cui i Dati Personali detenuti da noi sui nostri utenti
            del Servizio sono tra gli asset trasferiti.
          </p>
        </li>
        <li>
          <p>
            <strong>Per altri scopi</strong>: Possiamo utilizzare le tue
            informazioni per altri scopi, come l'analisi dei dati,
            l'identificazione delle tendenze di utilizzo, la determinazione
            dell'efficacia delle nostre campagne promozionali e per valutare e
            migliorare il nostro Servizio, i nostri prodotti, servizi, marketing
            e la tua esperienza.
          </p>
        </li>
      </ul>
      <p>
        Possiamo condividere le tue informazioni personali nelle seguenti
        situazioni:
      </p>
      <ul style={{ marginBottom: "30px", marginLeft: "30px" }}>
        <li style={{ marginBottom: "10px" }}>
          <strong>Con Fornitori di Servizi:</strong> Possiamo condividere le tue
          informazioni personali con Fornitori di Servizi per monitorare e
          analizzare l'uso del nostro Servizio, per contattarti.
        </li>
        <li style={{ marginBottom: "10px" }}>
          <strong>Per trasferimenti aziendali:</strong> Possiamo condividere o
          trasferire le tue informazioni personali in relazione a, o durante
          negoziati di, qualsiasi fusione, vendita di beni della Società,
          finanziamento o acquisizione di tutta o parte della nostra attività a
          un'altra società.
        </li>
        <li style={{ marginBottom: "10px" }}>
          <strong>Con Affiliati:</strong> Possiamo condividere le tue
          informazioni con i nostri affiliati, in tal caso richiederemo a tali
          affiliati di rispettare questa Informativa sulla Privacy. Gli
          affiliati includono la nostra società madre e qualsiasi altra
          sussidiaria, partner di joint venture o altre società che controlliamo
          o che sono sotto il nostro comune controllo.
        </li>
        <li style={{ marginBottom: "10px" }}>
          <strong>Con partner commerciali:</strong> Possiamo condividere le tue
          informazioni con i nostri partner commerciali per offrirti determinati
          prodotti, servizi o promozioni.
        </li>
        <li style={{ marginBottom: "10px" }}>
          <strong>Con altri utenti:</strong> quando condividi informazioni
          personali o interagisci in aree pubbliche con altri utenti, tali
          informazioni possono essere visualizzate da tutti gli utenti e possono
          essere distribuite pubblicamente all'esterno.
        </li>
        <li style={{ marginBottom: "10px" }}>
          <strong>Con il tuo consenso</strong>: possiamo divulgare le tue
          informazioni personali per qualsiasi altro scopo con il tuo consenso.
        </li>
      </ul>
      <h3>Conservazione dei tuoi dati personali</h3>
      <p>
        La Società conserverà i tuoi Dati Personali solo per il tempo necessario
        per gli scopi stabiliti in questa Informativa sulla Privacy.
        Conserveremo e utilizzeremo i tuoi Dati Personali nella misura
        necessaria per adempiere ai nostri obblighi legali (ad esempio, se siamo
        tenuti a conservare i tuoi dati per rispettare le leggi applicabili),
        risolvere dispute ed applicare i nostri accordi legali e le nostre
        politiche.
      </p>
      <p>
        La Società conserverà anche i Dati di Utilizzo per scopi di analisi
        interna. I Dati di Utilizzo sono generalmente conservati per un periodo
        di tempo più breve, tranne quando tali dati sono utilizzati per
        rafforzare la sicurezza o migliorare la funzionalità del nostro
        Servizio, o siamo legalmente obbligati a conservare tali dati per
        periodi più lunghi.
      </p>
      <h3>Trasferimento dei tuoi dati personali</h3>
      <p>
        Le tue informazioni, incluse i Dati Personali, sono elaborate presso gli
        uffici operativi della Società e in qualsiasi altro luogo in cui si
        trovano le parti coinvolte nel trattamento. Ciò significa che queste
        informazioni possono essere trasferite a — e mantenute su — computer
        situati al di fuori del tuo stato, provincia, paese o altra
        giurisdizione governativa dove le leggi sulla protezione dei dati
        possono differire da quelle della tua giurisdizione.
      </p>
      <p>
        Il tuo consenso a questa Informativa sulla Privacy seguito dalla tua
        presentazione di tali informazioni rappresenta il tuo accordo a tale
        trasferimento.
      </p>
      <p>
        La Società adotterà tutte le misure ragionevolmente necessarie per
        garantire che i tuoi dati siano trattati in modo sicuro e in conformità
        con questa Informativa sulla Privacy e nessun trasferimento dei tuoi
        Dati Personali avrà luogo presso un'organizzazione o un paese a meno che
        non siano presenti controlli adeguati, incluso il sicuro dei tuoi dati e
        altre informazioni personali.
      </p>
      <h3>Cancellazione dei tuoi dati personali</h3>
      <p>
        Hai il diritto di cancellare o richiedere che noi ti assistiamo nella
        cancellazione dei Dati Personali che abbiamo raccolto su di te.
      </p>
      <p>
        Il nostro Servizio potrebbe darti la possibilità di cancellare alcune
        informazioni su di te all'interno del Servizio.
      </p>
      <p>
        Puoi aggiornare, modificare o cancellare le tue informazioni in
        qualsiasi momento accedendo al tuo Account, se ne possiedi uno, e
        visitando la sezione delle impostazioni dell'account che ti consente di
        gestire le tue informazioni personali. Puoi anche contattarci per
        richiedere l'accesso, la correzione o la cancellazione di eventuali
        informazioni personali che ci hai fornito.
      </p>
      <p>
        Tuttavia, ti preghiamo di notare che potremmo dover conservare
        determinate informazioni quando abbiamo un obbligo legale o una base
        giuridica per farlo.
      </p>
      <h3 style={{ marginBottom: "10px" }}>
        Divulgazione dei tuoi dati personali
      </h3>
      <h4>Transazioni commerciali</h4>
      <p>
        Se la Società è coinvolta in una fusione, acquisizione o vendita di
        attività, i tuoi Dati Personali possono essere trasferiti. Forniremo un
        avviso prima che i tuoi Dati Personali siano trasferiti e diventino
        soggetti a una diversa Informativa sulla Privacy.
      </p>
      <h4>Applicazione della legge</h4>
      <p>
        In determinate circostanze, la Società potrebbe essere tenuta a
        divulgare i tuoi Dati Personali se richiesto per farlo dalla legge o in
        risposta a richieste valide da parte di autorità pubbliche (ad esempio,
        un tribunale o un'agenzia governativa).
      </p>
      <h4>Altri requisiti legali</h4>
      <p>
        La Società può divulgare i Tuoi Dati Personali nella buona fede che tale
        azione sia necessaria per:
      </p>
      <ul style={{ marginBottom: "30px", marginLeft: "30px" }}>
        <li>Conformarsi a un obbligo legale</li>
        <li>Proteggere e difendere i diritti o la proprietà della Società</li>
        <li>
          Prevenire o indagare su possibili illeciti in relazione al Servizio
        </li>
        <li>
          Proteggere la sicurezza personale degli Utenti del Servizio o del
          pubblico
        </li>
        <li>Proteggere contro la responsabilità legale</li>
      </ul>
      <h3>Sicurezza dei Tuoi Dati Personali</h3>
      <p>
        La sicurezza dei Tuoi Dati Personali è importante per Noi, ma ricorda
        che nessun metodo di trasmissione su Internet o di archiviazione
        elettronica è sicuro al 100%. Pur facendo del nostro meglio per
        utilizzare mezzi commercialmente accettabili per proteggere i Tuoi Dati
        Personali, non possiamo garantirne la sicurezza assoluta.
      </p>
      <h2>Privacy dei Minori</h2>
      <p>
        Il nostro Servizio non è rivolto a persone di età inferiore ai 13 anni.
        Non raccogliamo consapevolmente informazioni personali identificabili da
        persone di età inferiore ai 13 anni. Se sei un genitore o un tutore e
        sei a conoscenza del fatto che tuo figlio ci ha fornito Dati Personali,
        ti preghiamo di contattarci. Se veniamo a conoscenza del fatto che
        abbiamo raccolto Dati Personali da persone di età inferiore ai 13 anni
        senza verifica del consenso genitoriale, adotteremo provvedimenti per
        rimuovere tali informazioni dai nostri server.
      </p>
      <p>
        Se dobbiamo fare affidamento sul consenso come base giuridica per il
        trattamento delle tue informazioni e il tuo paese richiede il consenso
        da parte di un genitore, potremmo richiedere il consenso dei tuoi
        genitori prima di raccogliere e utilizzare tali informazioni.
      </p>
      <h2>Link ad Altri Siti Web</h2>
      <p>
        Il nostro Servizio può contenere collegamenti ad altri siti web che non
        sono gestiti da Noi. Se fai clic su un link di terze parti, verrai
        reindirizzato al sito di quella terza parte. Ti consigliamo vivamente di
        rivedere l'Informativa sulla Privacy di ogni sito che visiti.
      </p>
      <p>
        Non abbiamo alcun controllo e non assumiamo alcuna responsabilità per i
        contenuti, le politiche sulla privacy o le pratiche di qualsiasi sito o
        servizio di terze parti.
      </p>
      <h2>Modifiche a questa Informativa sulla Privacy</h2>
      <p>
        Possiamo aggiornare la nostra Informativa sulla Privacy di tanto in
        tanto. Ti informeremo di eventuali modifiche pubblicando la nuova
        Informativa sulla Privacy su questa pagina.
      </p>
      <p>
        Ti informeremo via email e/o con un avviso prominente sul nostro
        Servizio, prima che la modifica diventi efficace e aggiorneremo la data
        di "Ultimo aggiornamento" in cima a questa Informativa sulla Privacy.
      </p>
      <p>
        Ti consigliamo di rivedere periodicamente questa Informativa sulla
        Privacy per eventuali modifiche. Le modifiche a questa Informativa sulla
        Privacy diventano effettive quando vengono pubblicate su questa pagina.
      </p>
      <h2>Contattaci</h2>
      <p>
        Se hai domande su questa Informativa sulla Privacy, puoi contattarci:
      </p>
      <ul style={{ marginLeft: "30px" }}>
        <li>Per email: supporto@{props.domain}</li>
      </ul>
    </section>
  );
};

export default Policy;
